import {useState} from "react";
import {sydneyDayOf} from "@artemis-group/aiw-contracts";
import {useProposal, type InstallDay} from "../hooks/slice-a";
import {day} from "../lib/format";
import {useT} from "../lib/i18n";

/** One saved day, one office action. Installer reports remain separate evidence. */
export function OfficeInstallDay({jobRef, installationId, updatedAt, item, onSaved}:{
  jobRef:string; installationId:string|null; updatedAt:string|null; item:InstallDay; onSaved:()=>Promise<unknown>;
}) {
  const {t}=useT();
  const propose=useProposal();
  const [notes,setNotes]=useState("");
  const [editing,setEditing]=useState(false);
  const [error,setError]=useState("");
  const closed=item.office_state?.state==="closed";
  const past=!!sydneyDayOf(item.date) && (sydneyDayOf(item.date)??"")<(sydneyDayOf(new Date().toISOString())??"");
  const save=async()=>{
    if(!installationId||!updatedAt||!item.id||!notes.trim()) {setError(t('installDay.noteRequired'));return;}
    setError("");
    const result=await propose.run("set_install_day_state",{
      job_ref:jobRef,installation_id:installationId,day_id:item.id,
      expected_updated_at:updatedAt,state:closed?"open":"closed",notes:notes.trim(),
    },t(closed?'installDay.reopened':'installDay.closed'),setError);
    if(result?.status==="executed") {setNotes("");setEditing(false);await onSaved();}
    else if(result?.status==="pending")setError(t('installDay.notSaved'));
  };
  return <li className="border-b py-3 text-sm">
    <div className="flex flex-wrap items-center gap-2">
      <span className="w-24 shrink-0 font-mono text-xs">{day(item.date)}</span>
      <span className="min-w-0 flex-1"><strong>{item.crew||t('installDay.crewUnknown')}</strong>{item.task?` · ${item.task}`:""}</span>
      <span className={closed?"text-success":"text-muted-foreground"}>{closed?t('installDay.officeClosed'):item.office_state?.state==="open"?t('installDay.reopened'):past?t('installDay.unverified'):t('installDay.planned')}</span>
      {item.id&&installationId&&updatedAt?<button type="button" className="min-h-10 rounded border px-3 font-medium text-primary" onClick={()=>{setEditing(v=>!v);setError("");}}>{closed?t('installDay.reopen'):t('installDay.close')}</button>:null}
    </div>
    {item.office_state?.at?<p className="ml-24 text-xs text-muted-foreground">{item.office_state.by||t('installDay.office')} · {item.office_state.notes}</p>:null}
    {item.done&&!closed?<p className="ml-24 text-xs text-muted-foreground">{t('installDay.installerRecorded')} · {day(item.done)}</p>:null}
    {editing?<div className="mt-2 ml-24 space-y-2">
      <label className="block text-xs font-medium">{t('installDay.note')}<textarea className="mt-1 block w-full rounded border bg-background p-2 text-sm" value={notes} onChange={e=>setNotes(e.target.value)} maxLength={4000} placeholder={closed?t('installDay.reopenHint'):t('installDay.closeHint')}/></label>
      {error?<p role="alert" className="text-destructive">{error}</p>:null}
      <button type="button" disabled={propose.busy||!notes.trim()} onClick={()=>void save()} className="min-h-10 rounded bg-primary px-3 text-primary-foreground disabled:opacity-50">{propose.busy?t('installDay.saving'):closed?t('installDay.confirmReopen'):t('installDay.confirmClose')}</button>
    </div>:null}
  </li>;
}
